import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ListHeader from "./list-header";
import ListBody from "./ListBody";

const List = ({ items, selectCustomGroup, newCustomGroup, deleteCustomGroup }) => {
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    setFilteredList(items);
  }, [items]);

  const onFilterList = (filterName) => {
    if (filterName.length > 0) {
      const filteredList = items.filter((item) => {
        return item.name.toLowerCase().includes(filterName.toLowerCase());
      });

      setFilteredList(filteredList);
    } else {
      setFilteredList(items);
    }
    console.log(filteredList)
  };

  return (
    <ListContainer>
      <ListHeader newCustomGroup={newCustomGroup} filterFunction={onFilterList} />
      <ListBody items={filteredList} selectCustomGroup={selectCustomGroup} deleteCustomGroup={deleteCustomGroup}/>
    </ListContainer>
  );
};

const ListContainer = styled.div`
  width: 100%;
`;

export default List;
